import { Link } from "@inertiajs/react";
import { ArrowLeft } from "lucide-react";
import type { ReactNode } from "react";
import { CompetitiveScoreChart } from "@/bizminer/App/PillarInsights/FunctionalInsights/_components/CompetitiveScoreChart.tsx";
import BizminerLayout from "@/bizminer/layouts/app/BizminerLayout.tsx";
import { bizminer_app_pillar_insight_functional_insights_path } from "@/routes";
import type { BizminerPillarInsight } from "@/types/serializers";
import { FunctionalInsightTabs } from "./FunctionalInsightTabs";

interface FunctionalInsightLayoutProps {
  pillar_insight: BizminerPillarInsight;
  category_id: string;
  current_tab: string;
  children: ReactNode;
}

export default function FunctionalInsightLayout({
  pillar_insight,
  category_id,
  current_tab,
  children,
}: FunctionalInsightLayoutProps) {
  const category = pillar_insight.analysis.categories.find(
    (c) => c.id === category_id,
  );

  return (
    <BizminerLayout>
      <div className="space-y-6">
        <div className="flex items-center space-x-4">
          <Link
            href={bizminer_app_pillar_insight_functional_insights_path(
              pillar_insight.id,
            )}
            className="flex items-center text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back to Functional Insights
          </Link>
        </div>

        <div>
          <h1 className="text-2xl font-bold text-foreground">
            {category?.name}
          </h1>
        </div>
        <div>
          <CompetitiveScoreChart
            pillar_insight={pillar_insight}
            category_id={category_id}
          />
        </div>
        <FunctionalInsightTabs
          currentTab={current_tab}
          pillarInsightId={pillar_insight.id}
          categoryId={category_id}
        />

        {children}
      </div>
    </BizminerLayout>
  );
}
